// src/assets/pdfjs-config.ts

// Import the default build of PDF.js
import * as pdfjsLib from 'pdfjs-dist';

// Set the workerSrc property to the correct worker file
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export default pdfjsLib;
